export default {
  loading: false,
  error: false,
  listSubOrg: [],
  isEmpty: true,
  totalPages: 1
}
